import { cefr, clb, eld, nrs } from '../constants/levels'

const getHitLevelsByType = (type, hit) => {
  const {
    cefr_levels: cefrLevels,
    clb_levels: clbLevels,
    eld_levels: eldLevels,
    nrs_levels: nrsLevels,
    levels,
  } = hit

  if (type === eld && eldLevels?.length) {
    return eldLevels
  }

  if (type === clb && clbLevels?.length) {
    return clbLevels
  }

  if (type === cefr && cefrLevels?.length) {
    return cefrLevels
  }

  if (type === nrs && nrsLevels?.length) {
    return nrsLevels
  }

  return levels
}

export default getHitLevelsByType
